import { server, shared } from '../../config';

export const SHOPIFY_BASE_URL = `https://shopify.com/authentication/${shared.SHOPIFY_SHOP_ID}/`;
export const SHOPIFY_LOGOUT_URL = `${SHOPIFY_BASE_URL}logout`;
export const REDIRECT_URI = `${shared.NEXTAUTH_URL}/api/auth/callback/shopify`;
export const BASIC_HEADERS = {
  'Content-Type': 'application/x-www-form-urlencoded',
  Authorization: `Basic ${btoa(
    `${server.SHOPIFY_CLIENT_ID}:${server.SHOPIFY_CLIENT_SECRET}`,
  )}`,
};

export const obtainToken = async (code, codeVerifier, provider) =>
  await fetch(SHOPIFY_BASE_URL + 'oauth/token', {
    method: 'POST',
    body: new URLSearchParams({
      grant_type: 'authorization_code',
      client_id: provider.clientId,
      client_secret: provider.clientSecret,
      redirect_uri: REDIRECT_URI,
      code,
      code_verifier: codeVerifier,
    }),
    headers: BASIC_HEADERS,
  });

// token contains all available tokens
export const refreshShopifyAccessToken = async token => {
  try {
    const response = await fetch(SHOPIFY_BASE_URL + 'oauth/token', {
      method: 'POST',
      body: new URLSearchParams({
        client_id: server.SHOPIFY_CLIENT_ID,
        client_secret: server.SHOPIFY_CLIENT_SECRET,
        grant_type: 'refresh_token',
        refresh_token: token.refresh_token,
      }),
      headers: BASIC_HEADERS,
    });

    const refreshedTokens = await response.json();

    if (!response.ok) {
      throw refreshedTokens;
    }
    return {
      ...token,
      access_token: refreshedTokens.access_token,
      expires_in: refreshedTokens.expires_in,
      refresh_token: refreshedTokens.refresh_token ?? token.refresh_token, // Fall back to old refresh token
    };
  } catch (error) {
    return {
      ...token,
      error: 'RefreshAccessTokenError',
    };
  }
};

export const shopifyLogoutRedirect = idToken => {
  const logoutRedirectUrl =
    `${SHOPIFY_LOGOUT_URL}?` +
    new URLSearchParams({
      id_token_hint: idToken,
      post_logout_redirect_uri: `https://${shared.DOMAIN_PUBLIC_NAME}/auth/login/`,
    });
  return logoutRedirectUrl;
};

// this API call is used to fetch the customer UUID
export const getCustomerUUID = async (id, accessToken) => {
  const response = await fetch(
    `https://${shared.API_BASE_URL}/api/v3/customers/${id}/`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'x-ollie-user-id': `${id}`,
      },
    },
  );

  const data = await response.json();

  return data.id;
};
